import posthog from "posthog-js";
const POSTHOG_KEY = import.meta.env.PUBLIC_POSTHOG_KEY as string | undefined;
if (POSTHOG_KEY) {
	const initPostHog = () => {
		posthog.init(POSTHOG_KEY, {
			api_host: "https://us.i.posthog.com",
			person_profiles: "identified_only",
			opt_out_capturing_by_default: true,
			disable_session_recording: true
		});
		// Sync with existing consent preference set before this script runs
		try {
			const stored = localStorage.getItem("qt.analytics.preference");
			if (stored === "granted") posthog.opt_in_capturing();
		} catch {}
	};
	if ("requestIdleCallback" in window) {
		requestIdleCallback(initPostHog, { timeout: 3e3 });
	} else {
		setTimeout(initPostHog, 2e3);
	}
}